var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOkContour = function SvgOkContour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.0001 18.3332C5.39758 18.3332 1.66675 14.6023 1.66675 9.99984C1.66675 5.39734 5.39758 1.6665 10.0001 1.6665C14.6026 1.6665 18.3334 5.39734 18.3334 9.99984C18.3334 14.6023 14.6026 18.3332 10.0001 18.3332ZM10.0001 16.6665C11.7682 16.6665 13.4639 15.9641 14.7141 14.7139C15.9644 13.4636 16.6667 11.7679 16.6667 9.99984C16.6667 8.23173 15.9644 6.53603 14.7141 5.28579C13.4639 4.03555 11.7682 3.33317 10.0001 3.33317C8.23197 3.33317 6.53628 4.03555 5.28604 5.28579C4.03579 6.53603 3.33341 8.23173 3.33341 9.99984C3.33341 11.7679 4.03579 13.4636 5.28604 14.7139C6.53628 15.9641 8.23197 16.6665 10.0001 16.6665Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.16889 13.416L5.63306 9.88021L6.81139 8.70188L9.16889 11.0594L13.8822 6.34521L15.0614 7.52355L9.16889 13.416Z"
  })));
};
export default SvgOkContour;